import React, { PureComponent } from 'react';
import _ from 'lodash';
import Checkbox from 'material-ui/Checkbox';
import TextField from 'material-ui/TextField';
import ImageSizeField from '../../../EditorUI/BaseUI/CustomWidthAndHeight/CustomWidthAndHeight';
import DebounceInput from 'react-debounce-input';
import EbayLinkChecker from 'shared/components/EbayLinkChecker';

export default class ImageProperties extends PureComponent {
  state = {
    keepOriginalSize: true,
  };

  componentWillMount() {
    const {img, initialImageProperties} = this.props;
    if (img && initialImageProperties) {
      const {href} = initialImageProperties;
      this.setState({keepOriginalSize: this.isOriginalSize(img, initialImageProperties), href});
    }
  }

  componentWillReceiveProps(nextProps) {
    const {img, initialImageProperties} = nextProps;
    if (img && initialImageProperties && (this.props.img !== img || this.props.initialImageProperties !== initialImageProperties)) {
      const {href} = initialImageProperties;
      this.setState({keepOriginalSize: initialImageProperties.newElement || this.isOriginalSize(img, initialImageProperties), href});
    }
  }

  getTitle() {
    return this.refs.title.getValue();
  }

  getLink() {
    if (this.state.href) {
      return this.state.href;
    }
    const {initialImageProperties} = this.props;
    if (initialImageProperties) {
      return initialImageProperties.href;
    }
    return '';
  }

  getHeight() {
    const {img} = this.props;
    const {keepOriginalSize} = this.state;
    return keepOriginalSize ? img.height : this.refs.size.getHeight();
  }

  getWidth() {
    const {img} = this.props;
    const {keepOriginalSize} = this.state;
    return keepOriginalSize ? img.width : this.refs.size.getWidth();
  }

  getAspectRatio() {
    return this.refs.size.getAspectRatio();
  }

  getImageProperties = () => {
    return {
      title: this.getTitle(),
      href: this.getLink(),
      height: this.getHeight(),
      width: this.getWidth(),
      aspectRatio: this.getAspectRatio()
    };
  };

  isOriginalSize(img, imageProperties) {
    return Math.abs(img.width - imageProperties.width) < 2 && Math.abs(img.height - imageProperties.height) < 2;
  }

  render() {
    const {img} = this.props;
    let {initialImageProperties} = this.props;
    const { keepOriginalSize, linkValid, href } = this.state;
    if (_.get(initialImageProperties, 'newElement', false)) {
      initialImageProperties = null;
    }
    let imageHeight;
    let imageWidth;
    if (img) {
      imageHeight = img.height;
      imageWidth = img.width;
    }
    if (!keepOriginalSize) {
      if (initialImageProperties) {
        if (initialImageProperties.height) {
          imageHeight = initialImageProperties.height;
        }
        if (initialImageProperties.height) {
          imageWidth = initialImageProperties.width;
        }
      }
    }
    const imageSizeStyle = {transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms'};
    if (keepOriginalSize) {
      imageSizeStyle.transform = 'translateY(50%)';
      imageSizeStyle.opacity = '0';
    }

    return (
      <div>
        <TextField
          key="title"
          style={{width: '100%'}}
          floatingLabelText="Image Title (Optional)"
          ref="title"
          defaultValue={initialImageProperties && initialImageProperties.title}
        />
        <EbayLinkChecker style={{marginTop: 5, marginBottom: 5}} onChange={(linkValid) => this.setState({linkValid})} href={href}/>
        <DebounceInput
          element = {TextField}
          errorStyle={{float: 'left'}}
          style={{width: '100%', top: -10}}
          floatingLabelText="Image Link (Optional)"
          ref="link"
          value={href || ''}
          hintText="Insert Link Here"
          onChange={({target: {value}}) => {
            this.setState({href: value});
          }}
          debounceTimeout = {linkValid ? 2000 : undefined}
        />
        <Checkbox
          key="keepOriginalSize"
          checked={keepOriginalSize}
          label={'Keep Image’s original size' + (img ? ' (' + img.width + ' X ' + img.height + ')' : '')}
          style={{fontSize: 16}}
          onCheck={(event, checked) => {this.setState({keepOriginalSize: checked});}}
          disabled={_.isNil(img)}
        />
        <div style={{ overflow: 'hidden' }}>
          <ImageSizeField
            key="imageSize"
            defaultHeight={imageHeight}
            defaultWidth={imageWidth}
            initialAspectRatio={initialImageProperties && initialImageProperties.aspectRatio}
            ref="size"
            style={imageSizeStyle}
          />
        </div>
      </div>
    );
  }
}
